export default {
  childrenByParentId: {},
  loadingByParentId: {},
  errorByParentId: {},
};
